import { Controller } from "@hotwired/stimulus"

export class UserMergeFormController extends Controller {
  static targets = ["frame"]
  static values = { previewUrl: String }

  loserChanged(event) {
    const id = event.target.value
    if (!id || !this.hasFrameTarget) return
    this.frameTarget.src = `${this.previewUrlValue}?loser_id=${encodeURIComponent(id)}`
  }
}
